import { compose, dissoc } from 'ramda'

import { getAuthToken, getWorkspaceName, handle401 } from '../session/sessionStorage'
import { getLocale } from '../locale/locale'
import { useBtimeLogger } from '../logger/btimeLogs/log'
import { useSubdomain } from '../../utils/contexts/UrlProvider'

export default {
  use401Handler: () => {
    const btLogger = useBtimeLogger()

    return () => {
      btLogger.warn({ name: 'forceLogout' })
      handle401()
    }
  },

  useGetAuth: () => getAuthToken,

  useGetWorkspace: () => {
    const workspace = useSubdomain()
    const localStorageWorkspace = getWorkspaceName()
    return () => localStorageWorkspace || workspace
  },

  useGetLocale: () => getLocale,

  useGetFixedHeaders: () => () => ({}),

  useOnSuccess: () => {
    const btLogger = useBtimeLogger()
    return (_, payload) => {
      // Dont log errors on this methods because they are already managed directitly on each call
      if (!['POST', 'PUT', 'PATCH', 'DELETE'].includes(payload.method) && !payload?.url?.includes('logging')) {
        const logData = { payload: compose(dissoc('headers'), dissoc('executionTime'))(payload) }
        btLogger.monitor({ name: 'monitorApiCall', data: logData, executionTime: payload.executionTime })
      }
    }
  },

  useOnError: () => {
    const btLogger = useBtimeLogger()
    return (error, payload) => {
      // Dont log errors on this methods because they are already managed directitly on each call
      if (!['POST', 'PUT', 'PATCH', 'DELETE'].includes(payload.method)) {
        const logData = { error, payload: dissoc('headers', payload) }
        btLogger.error({ name: 'apiCall', data: logData })
      }
    }
  }
}
